import {
  INotification,
  notificationEnums,
} from "@freetech/models/notifications";

export const getStakeholderNotificationDescription = (
  notification: INotification
): string | undefined => {
  const { type, afterData } = notification;

  switch (type) {
    case notificationEnums.StakeholderNotificationType
      .STAKEHOLDER_INVOICE_RECIEVED:
      if (
        afterData &&
        "invoiceNumber" in afterData &&
        "dueDate" in afterData
      ) {
        const dueDate = new Date(afterData.dueDate as string);
        return `Invoice #${afterData.invoiceNumber} - Due ${dueDate.toLocaleDateString()}`;
      }
      return "Please review and process your invoice";

    case notificationEnums.StakeholderNotificationType
      .STAKEHOLDER_INVOICE_PAID:
      if (
        afterData &&
        "invoiceNumber" in afterData &&
        "paidDate" in afterData
      ) {
        const paidDate = new Date(afterData.paidDate as string);
        return `Invoice #${afterData.invoiceNumber} - Paid ${paidDate.toLocaleDateString()}`;
      }
      return "Thank you for your payment";

    case notificationEnums.StakeholderNotificationType
      .STAKEHOLDER_CSA_RECIEVED:
      if (afterData && "description" in afterData) {
        return afterData.description as string;
      }
      return "Please review and sign the agreement";

    case notificationEnums.StakeholderNotificationType
      .STAKEHOLDER_PAYMENT_CREATED:
      if (afterData && "description" in afterData) {
        return afterData.description as string;
      }
      return "Payment is being processed";

    case notificationEnums.StakeholderNotificationType
      .STAKEHOLDER_PAYMENT_COMPLETED:
      if (afterData && "completedDate" in afterData) {
        const completedDate = new Date(afterData.completedDate as string);
        return `Completed on ${completedDate.toLocaleDateString()}`;
      }
      return "Payment has been successfully processed";

    case notificationEnums.StakeholderNotificationType
      .STAKEHOLDER_PAYMENT_FAILED:
      if (afterData && "failureReason" in afterData) {
        return `Reason: ${afterData.failureReason}`;
      }
      return "Please contact support for assistance";

    case notificationEnums.StakeholderNotificationType
      .STAKEHOLDER_PAYMENT_REVERSED:
      if (afterData && "reversalReason" in afterData) {
        return `Reason: ${afterData.reversalReason}`;
      }
      return "Payment has been returned to your account";

    default:
      return undefined;
  }
};
